import React from "react";

export function LegalAdvisorDashboard() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-start" style={{ backgroundColor: '#F1EBDB' }}>
      <div className="max-w-4xl w-full space-y-8 bg-[#F1EBDB] p-10 rounded-xl  mt-10">
        <div>
          <h1 className="text-3xl font-bold text-center text-black">Legal Advisor Dashboard</h1>
          <p className="mt-2 text-sm text-[#F16745] text-center mb-8">
            Manage your legal advisory tasks and register new users
          </p>
        </div>

        <div className="flex justify-center">
          <button
            onClick={() => window.open('/users/new', '_blank')}
            className="group relative flex items-center justify-center gap-2 py-4 px-8 border border-transparent text-lg font-medium rounded-md text-white bg-[#F16745] hover:bg-[#F16745]/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F16745] disabled:opacity-50 disabled:cursor-not-allowed transform transition-all duration-150 hover:scale-[1.02]"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            Register New User 
          </button>
        </div>
      </div>
    </div>
  );
} 


{/* <div className="flex flex-col items-center justify-start gap-4 pt-10">
<h1 className="text-2xl font-bold text-center text-foreground">Legal Advisor Dashboard</h1>
<button
  onClick={() => window.open('/register', '_blank')}
  className="bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg shadow-md transition-colors duration-200 flex items-center justify-center gap-2 py-10 px-10 text-xl"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
  Register New User 
</button>
</div> */}